import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The public, archive-only receipt. It runs only after the public Tournament
 * response says the tournament is archived; a completed-but-unpublished event
 * never turns a normal 404 into a player-facing error state.
 */
export function useTournamentArchive(tournamentId: string, enabled: boolean) {
  return useQuery<Schema["TournamentPublicArchiveResponse"]>({
    queryKey: queryKeys.tournaments.archive(tournamentId),
    queryFn: () => tournamentApi.getPublicArchive(tournamentId),
    enabled,
  });
}
